// src/AsyncStream.ts
var AsyncStream = class _AsyncStream {
  constructor(iterator) {
    this.iterator = iterator;
  }
  static fromIterable(fn) {
    return new _AsyncStream(fn[Symbol.asyncIterator]());
  }
  static fromFn(fn) {
    return new _AsyncStream(fn());
  }
  [Symbol.asyncIterator]() {
    return this.iterator;
  }
};
var MediaResponse = class {
  constructor(mimeType, data) {
    this.mimeType = mimeType;
    this.data = data;
  }
};

export {
  AsyncStream,
  MediaResponse
};
//# sourceMappingURL=chunk-SGBCNXYH.mjs.map